import {omit, orderBy} from 'lodash';
import {connect} from 'react-redux';
import {getBuckets, getRecommendationBucketColleges} from 'src/actions/recommendations';
import {TARGET_ME_KEY} from 'src/services/RecommendationsService';
import Buckets from './RecommendationBuckets';
import {followCollege, unfollowCollege} from 'src/actions/studentCollege';
import {setCollegeAppStatus} from 'shared/college-application-status/actions/college-application-status';

const orderedBuckets = (state) =>
  orderBy(Object.values(omit(state.recommendations.buckets, TARGET_ME_KEY)), 'index');

const mapStateToProps = (state) => ({
  targetMeBucket: state.recommendations.buckets[TARGET_ME_KEY],
  recommendationsShownEventId: state.recommendations.recommendationsShownEventId,
  buckets: orderedBuckets(state),
  user: state.collegeSearch.user,
  collegeApplicationStatuses: state.collegeApplicationStatuses,
});

export default connect(mapStateToProps, {
  getBuckets,
  followCollege,
  unfollowCollege,
  getRecommendationBucketColleges,
  setCollegeAppStatus,
})(Buckets);
